export class EventTypes {
  static worldEvent = "world_event";
  static normalEvent = "normal_event";
  static keyEvent = "key_event";
}
